import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if(!d) return '—'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<1?'just now':m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }

const LANG_META = { powershell:{icon:'⚡',color:'#1d4ed8',bg:'#dbeafe'}, bash:{icon:'🐧',color:'#16a34a',bg:'#dcfce7'}, python:{icon:'🐍',color:'#d97706',bg:'#fef3c7'}, cmd:{icon:'⌨',color:'#64748b',bg:'#f1f5f9'} };
const CAT_META  = { remediation:{color:'#dc2626'}, audit:{color:'#7c3aed'}, configuration:{color:'#1d4ed8'}, deployment:{color:'#d97706'}, diagnostic:{color:'#0891b2'}, custom:{color:'#64748b'} };
const STATUS_META = { pending:{c:'#d97706',bg:'#fef3c7'}, running:{c:'#1d4ed8',bg:'#dbeafe'}, success:{c:'#16a34a',bg:'#dcfce7'}, failed:{c:'#dc2626',bg:'#fee2e2'}, timeout:{c:'#64748b',bg:'#f1f5f9'} };

const DEF_TMPL = { name:'', description:'', language:'powershell', osTarget:'windows', category:'custom', content:'', timeout:300 };

export default function Scripting({ user }) {
  const [templates,setTemplates]= useState([]);
  const [runs,    setRuns]     = useState([]);
  const [devices, setDevices]  = useState([]);
  const [tab,     setTab]      = useState('templates');
  const [loading, setLoading]  = useState(true);
  const [msg,     setMsg]      = useState({ text:'', type:'' });
  const [showForm,setShowForm] = useState(false);
  const [form,    setForm]     = useState(DEF_TMPL);
  const [saving,  setSaving]   = useState(false);
  const [runModal,setRunModal] = useState(null);
  const [selDevs, setSelDevs]  = useState([]);
  const [running, setRunning]  = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  const load = useCallback(async () => {
    try {
      const [tr, rr, dr] = await Promise.all([
        axios.get('/api/scripting/templates',auth()),
        axios.get('/api/scripting/runs?limit=50',auth()),
        axios.get('/api/agents',auth()),
      ]);
      setTemplates(tr.data); setRuns(rr.data); setDevices(dr.data.filter?dr.data.filter(d=>!d.archivedAt):dr.data);
    } catch(e) { flash('Failed','error'); } finally { setLoading(false); }
  },[]);
  useEffect(()=>{ load(); },[load]);

  async function saveTemplate(e) {
    e.preventDefault(); setSaving(true);
    try { await axios.post('/api/scripting/templates',form,auth()); flash('Template created'); setShowForm(false); setForm(DEF_TMPL); load(); }
    catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }

  async function runScript() {
    if(!selDevs.length||!runModal)return;
    setRunning(true);
    try {
      const r = await axios.post('/api/scripting/run',{ templateId:runModal.id, deviceIds:selDevs },auth());
      flash(`Queued on ${r.data.queued} device(s)`); setRunModal(null); setSelDevs([]); setTimeout(load,2000);
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setRunning(false); }
  }

  async function delTemplate(id) {
    if(!window.confirm('Delete?'))return;
    try { await axios.delete(`/api/scripting/templates/${id}`,auth()); flash('Deleted'); load(); }
    catch(e) { flash('Failed','error'); }
  }

  const userTemplates = templates.filter(t=>!t.isBuiltIn);
  const builtIn       = templates.filter(t=>t.isBuiltIn);

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Scripting Engine</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Run PowerShell, Bash, Python scripts on managed endpoints</p></div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Template</button>
      </div>
      <div style={{display:'flex',gap:2,marginBottom:16,borderBottom:'2px solid #f1f5f9'}}>
        {[['templates','Templates'],['runs','Run History']].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{padding:'8px 16px',border:'none',borderBottom:tab===id?'2px solid #1e40af':'2px solid transparent',background:'none',cursor:'pointer',fontWeight:600,fontSize:13,color:tab===id?'#1e40af':'#64748b',marginBottom:-2}}>{label}</button>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> : tab==='templates' ? (
        <>
          {userTemplates.length>0&&(
            <div style={{marginBottom:24}}>
              <div style={{fontWeight:700,fontSize:14,color:'#374151',marginBottom:12}}>Custom Templates</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))',gap:12}}>
                {userTemplates.map(t=>{ const lm=LANG_META[t.language]||LANG_META.powershell; const cm=CAT_META[t.category]||{color:'#64748b'};
                  return <TemplateCard key={t.id} t={t} lm={lm} cm={cm} onRun={()=>{setRunModal(t);setSelDevs([]);}} onDel={()=>delTemplate(t.id)} />;
                })}
              </div>
            </div>
          )}
          <div>
            <div style={{fontWeight:700,fontSize:14,color:'#374151',marginBottom:12}}>Built-in Library ({builtIn.length})</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))',gap:12}}>
              {builtIn.map(t=>{ const lm=LANG_META[t.language]||LANG_META.powershell; const cm=CAT_META[t.category]||{color:'#64748b'};
                return <TemplateCard key={t.id} t={t} lm={lm} cm={cm} onRun={()=>{setRunModal(t);setSelDevs([]);}} builtin />;
              })}
            </div>
          </div>
        </>
      ) : (
        runs.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>📋</div><div style={{fontWeight:600,marginTop:12}}>No runs yet</div></div> : (
          <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,overflow:'hidden'}}>
            <thead><tr style={{background:'#f8fafc'}}>
              {['Device','Status','Triggered By','Time','Output/Error'].map(h=><th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748b',borderBottom:'1px solid #f1f5f9'}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {runs.map(r=>{ const sm=STATUS_META[r.status]||{c:'#64748b',bg:'#f1f5f9'};
                return <tr key={r.id} style={{borderBottom:'1px solid #f8fafc'}}>
                  <td style={{padding:'9px 14px',fontWeight:600,fontSize:13}}>{r.device?.hostname||'—'}</td>
                  <td style={{padding:'9px 14px'}}><span style={{background:sm.bg,color:sm.c,borderRadius:4,padding:'2px 7px',fontSize:11,fontWeight:700}}>{r.status}</span></td>
                  <td style={{padding:'9px 14px',fontSize:12,color:'#64748b'}}>{r.triggeredBy}</td>
                  <td style={{padding:'9px 14px',fontSize:12,color:'#94a3b8'}}>{ts(r.createdAt)}</td>
                  <td style={{padding:'9px 14px',fontSize:11,color:'#64748b',maxWidth:220,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontFamily:'monospace'}}>{r.output||r.error||'—'}</td>
                </tr>;
              })}
            </tbody>
          </table>
        )
      )}

      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:580,maxWidth:'95vw',maxHeight:'90vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Script Template</h3>
            <form onSubmit={saveTemplate}>
              {[['Name*','name'],['Description','description']].map(([l,k])=>(
                <div key={k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              ))}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:14}}>
                {[['Language','language',['powershell','bash','python','cmd']],['OS Target','osTarget',['windows','linux','macos','all']],['Category','category',['remediation','audit','configuration','deployment','diagnostic','custom']]].map(([l,k,opts])=>(
                  <div key={k}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                    <select value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                      {opts.map(o=><option key={o} value={o}>{o}</option>)}
                    </select></div>
                ))}
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Script Content*</label>
                <textarea value={form.content} onChange={e=>setForm({...form,content:e.target.value})} required rows={8}
                  placeholder={form.language==='powershell'?'# PowerShell script\nGet-ComputerInfo | ConvertTo-Json':form.language==='bash'?'#!/bin/bash\nuname -a':'# Python script\nimport platform\nprint(platform.node())'}
                  style={{width:'100%',padding:10,border:'1px solid #d1d5db',borderRadius:8,fontSize:12,fontFamily:'monospace',boxSizing:'border-box',resize:'vertical'}} />
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Saving...':'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {runModal&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:460,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 4px',fontSize:18,fontWeight:700}}>Run: {runModal.name}</h3>
            <p style={{margin:'0 0 14px',color:'#64748b',fontSize:13}}>{runModal.language} · {runModal.osTarget}</p>
            <div style={{maxHeight:200,overflow:'auto',border:'1px solid #e2e8f0',borderRadius:8,marginBottom:12}}>
              <div style={{display:'flex',gap:8,padding:'8px 12px',background:'#f8fafc',borderBottom:'1px solid #f1f5f9'}}>
                <button onClick={()=>setSelDevs(devices.filter(d=>d.status==='online').map(d=>d.id))} style={{fontSize:11,padding:'3px 8px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:4,cursor:'pointer'}}>All Online</button>
                <button onClick={()=>setSelDevs([])} style={{fontSize:11,padding:'3px 8px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:4,cursor:'pointer'}}>Clear</button>
              </div>
              {devices.map(d=><label key={d.id} style={{display:'flex',gap:8,padding:'7px 12px',borderBottom:'1px solid #f8fafc',cursor:'pointer',background:selDevs.includes(d.id)?'#eff6ff':'#fff'}}>
                <input type="checkbox" checked={selDevs.includes(d.id)} onChange={e=>setSelDevs(s=>e.target.checked?[...s,d.id]:s.filter(x=>x!==d.id))} />
                <span style={{flex:1,fontSize:13,fontWeight:500}}>{d.hostname}</span>
                <span style={{fontSize:11,color:d.status==='online'?'#16a34a':'#94a3b8',fontWeight:600}}>{d.status==='online'?'●':'○'}</span>
              </label>)}
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button onClick={()=>setRunModal(null)} style={{padding:'9px 18px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
              <button onClick={runScript} disabled={running||!selDevs.length} style={{padding:'9px 18px',background:running||!selDevs.length?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:running?'default':'pointer'}}>
                {running ? 'Running...' : `▶ Run on ${selDevs.length} device(s)`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TemplateCard({ t, lm, cm, onRun, onDel, builtin }) {
  return (
    <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:10,padding:16}}>
      <div style={{display:'flex',gap:10,alignItems:'flex-start',marginBottom:8}}>
        <div style={{width:36,height:36,borderRadius:8,background:lm.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0}}>{lm.icon}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:700,fontSize:13,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{t.name}</div>
          <div style={{fontSize:11,color:'#64748b',marginTop:1}}>{t.description||t.language}</div>
        </div>
        <div style={{display:'flex',gap:4,flexShrink:0}}>
          <span style={{background:lm.bg,color:lm.color,borderRadius:4,padding:'1px 6px',fontSize:9,fontWeight:700}}>{t.language}</span>
          <span style={{background:'#f1f5f9',color:cm.color,borderRadius:4,padding:'1px 6px',fontSize:9,fontWeight:700}}>{t.category}</span>
        </div>
      </div>
      <div style={{background:'#0f172a',borderRadius:6,padding:'6px 10px',marginBottom:10,fontSize:10,fontFamily:'monospace',color:'#94a3b8',overflow:'hidden',height:40,lineHeight:1.4}}>
        {t.content?.substring(0,120)}
      </div>
      <div style={{display:'flex',gap:6}}>
        <button onClick={onRun} style={{flex:1,background:'#1e40af',color:'#fff',border:'none',borderRadius:6,padding:'6px',fontSize:11,fontWeight:600,cursor:'pointer'}}>▶ Run</button>
        {!builtin&&<button onClick={onDel} style={{background:'#fee2e2',border:'none',borderRadius:6,padding:'6px 8px',fontSize:11,cursor:'pointer',color:'#dc2626'}}>🗑</button>}
      </div>
    </div>
  );
}
